var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFresher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_6920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C14.5105 0 11.6719 2.9089 11.6719 6.39844C11.6719 9.88798 14.5105 12.7266 18 12.7266C21.4895 12.7266 24.3281 9.88798 24.3281 6.39844C24.3281 2.9089 21.4895 0 18 0Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.11 12.7266H18.0007H15.8913C14.4036 12.7266 12.9661 13.1111 11.6592 13.7653C13.8789 14.3642 15.9688 15.2268 18.0007 16.393C20.0326 15.2268 22.1225 14.3642 24.3421 13.7653C23.0353 13.1111 21.5977 12.7266 20.11 12.7266Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8906 19.0547C32.7256 19.0547 31.7812 19.9991 31.7812 21.1641V25.3828C31.7812 26.5477 32.7256 27.4922 33.8906 27.4922C35.0556 27.4922 36 26.5477 36 25.3828V21.1641C36 19.9991 35.0556 19.0547 33.8906 19.0547Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 19.0547C0.944367 19.0547 0 19.9991 0 21.1641V25.3828C0 26.5477 0.944367 27.4922 2.10938 27.4922C3.27438 27.4922 4.21875 26.5477 4.21875 25.3828V21.1641C4.21875 19.9991 3.27438 19.0547 2.10938 19.0547Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 14.8359C2.5811 14.8359 2.10938 15.3077 2.10938 15.8906V16.9453C4.43609 16.9453 6.32812 18.8374 6.32812 21.1641V25.3828C6.32812 27.7095 4.43609 29.6016 2.10938 29.6016V30.6562C2.10938 31.2392 2.5811 31.7109 3.16406 31.7109C8.57116 31.7109 12.8946 33.4185 16.9453 36V18.2527C12.8763 15.9197 8.50099 14.8359 3.16406 14.8359Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8906 16.9453V15.8906C33.8906 15.3077 33.4189 14.8359 32.8359 14.8359C27.499 14.8359 23.1237 15.9197 19.0547 18.2527V36C23.1054 33.4185 27.4288 31.7109 32.8359 31.7109C33.4189 31.7109 33.8906 31.2392 33.8906 30.6562V29.6016C31.5639 29.6016 29.6719 27.7095 29.6719 25.3828V21.1641C29.6719 18.8374 31.5639 16.9453 33.8906 16.9453Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_6920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFresher);
export default __webpack_public_path__ + "static/media/fresher.b4a7af2b5dcdf28c442a0eba7d9f62b4.svg";
export { ForwardRef as ReactComponent };